import { get } from './http'

export function getZlmbanner() {
  return get('/api/banner/zlmbanner')
}
